import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["aria-describedby"]
const _hoisted_3 = { class: "govuk-fieldset__legend govuk-fieldset__legend--m" }
const _hoisted_4 = { class: "govuk-fieldset__heading" }
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-visually-hidden" }, "Error:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "govuk-date-input__item" }
const _hoisted_11 = { class: "govuk-form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "govuk-label govuk-date-input__label",
  for: "passport-issued-day"
}, " Day ", -1)
const _hoisted_13 = ["id", "name"]
const _hoisted_14 = { class: "govuk-date-input__item" }
const _hoisted_15 = { class: "govuk-form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "govuk-label govuk-date-input__label",
  for: "passport-issued-month"
}, " Month ", -1)
const _hoisted_17 = ["id", "name"]
const _hoisted_18 = { class: "govuk-date-input__item" }
const _hoisted_19 = { class: "govuk-form-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "govuk-label govuk-date-input__label",
  for: "passport-issued-year"
}, " Year ", -1)
const _hoisted_21 = ["id", "name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.fieldGroupId,
    class: _normalizeClass(_ctx.fieldGroupClassList)
  }, [
    _createElementVNode("fieldset", {
      class: "govuk-fieldset",
      role: "group",
      "aria-describedby": _ctx.inputDescribedBy
    }, [
      _createElementVNode("legend", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.field.label), 1)
      ]),
      (_ctx.field.hint)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: _ctx.hintId,
            class: "govuk-hint"
          }, _toDisplayString(_ctx.field.hint), 9, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.field.errors)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            id: _ctx.errorId,
            class: "govuk-error-message"
          }, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.errors, (error, index) => {
              return (_openBlock(), _createElementBlock("span", { key: index }, [
                _createTextVNode(_toDisplayString(error.error), 1),
                _hoisted_8
              ]))
            }), 128))
          ], 8, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "govuk-date-input",
        id: _ctx.field.name
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputDay) = $event)),
              class: _normalizeClass(_ctx.inputClassList(2)),
              id: _ctx.getInputId('day'),
              name: _ctx.getInputId('day'),
              type: "text",
              pattern: "[0-9]*",
              inputmode: "numeric"
            }, null, 10, _hoisted_13), [
              [_vModelText, _ctx.inputDay]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputMonth) = $event)),
              class: _normalizeClass(_ctx.inputClassList(2)),
              id: _ctx.getInputId('month'),
              name: _ctx.getInputId('month'),
              type: "text",
              pattern: "[0-9]*",
              inputmode: "numeric"
            }, null, 10, _hoisted_17), [
              [_vModelText, _ctx.inputMonth]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputYear) = $event)),
              class: _normalizeClass(_ctx.inputClassList(4)),
              id: _ctx.getInputId('year'),
              name: _ctx.getInputId('year'),
              type: "text",
              pattern: "[0-9]*",
              inputmode: "numeric"
            }, null, 10, _hoisted_21), [
              [_vModelText, _ctx.inputYear]
            ])
          ])
        ])
      ], 8, _hoisted_9)
    ], 8, _hoisted_2)
  ], 10, _hoisted_1))
}